import { useQuery } from '@tanstack/react-query'
import { useEffect } from 'react'

import { useToast } from '@/components/ui'
import { configsService } from '@/services/http/configsService'

export const useAppearance = () => {
  const { toast } = useToast()

  const {
    data: appearance,
    isError,
    isLoading,
    refetch: refetchAppearance,
  } = useQuery({
    queryKey: ['appearance'],
    queryFn: () => configsService.getAppearance(),
  })

  useEffect(() => {
    if (isError)
      toast({
        title: 'Erro ao buscar dados da aparência',
        variant: 'destructive',
      })
  }, [isError, toast])

  return {
    appearance,
    isLoading,
    refetchAppearance,
  }
}
